import { IFGameTypeRsp } from "../api/apiRsp/IFGameTypeRsp";
import { IFBigWins, IFHomeRsp } from "../api/apiRsp/IFHomeRsp";

export interface CasinoHomeData {
  lobbyData?: IFHomeRsp;
  bigWinsData?: IFBigWins[];
  playedPreviewData?: IFGameTypeRsp;
}

export interface CasinoRequestConfig {
  path: string;
  type?: string;
}

type FetcherFn = <T>(
  API: CasinoRequestConfig,
  args: { arg: any }
) => Promise<T>;

export function getCasinoSWRKey(token?: string, isLogin = false) {
  return `getCasino|${isLogin && token ? token : "guest"}`;
}

export async function fetchCasinoHomeData(
  token?: string,
  isLogin = false,
  fetcherFn?: FetcherFn
): Promise<CasinoHomeData> {
  if (!fetcherFn) {
    throw new Error("fetcherFn is required");
  }

  const lobbyPromise = fetcherFn<IFHomeRsp>(
    { path: "/api/game/lobby", type: "get" },
    { arg: {} }
  );
  const bigWinningsPromise = fetcherFn<IFBigWins[]>(
    { path: "/api/game/bigwinnings", type: "get" },
    { arg: {} }
  );
  const playedPreviewPromise = isLogin && token
    ? fetcherFn<IFGameTypeRsp>(
        { path: "/api/game/played/list", type: "get" },
        { arg: { page: 1, pageSize: 6 } }
      )
    : Promise.resolve(undefined);

  const [lobbyData, bigWinsData, playedPreviewData] = await Promise.all([
    lobbyPromise,
    bigWinningsPromise,
    playedPreviewPromise,
  ]);

  return {
    lobbyData,
    bigWinsData,
    playedPreviewData,
  };
}
